export default async function ({ store, redirect, params }) {}
